import { render, staticRenderFns } from "./surveys.vue?vue&type=template&id=0f63d422&scoped=true&"
import script from "./surveys.vue?vue&type=script&lang=js&"
export * from "./surveys.vue?vue&type=script&lang=js&"
import style0 from "./surveys.vue?vue&type=style&index=0&id=0f63d422&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f63d422",
  null
  
)

component.options.__file = "surveys.vue"
export default component.exports